<template>
  <div class="mt-4">
    <button
      v-if="!formVisible && !submitted"
      type="button"
      class="text-xs text-gray-500 underline hover:text-gray-700 focus:outline-hidden"
      @click="formVisible = true"
    >
      {{ t("report_button") }}
    </button>

    <div v-if="formVisible && !submitted" class="mt-2 space-y-2">
      <textarea
        v-model="comment"
        :placeholder="t('textarea_placeholder')"
        rows="3"
        class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm text-gray-800 placeholder-gray-400 focus:border-gray-400 focus:outline-hidden focus:ring-1 focus:ring-gray-400"
      />
      <div class="flex items-center gap-2">
        <SecondaryButton :loading="loading" :disabled="!comment.trim()" @click="submit">
          {{ t("submit_button") }}
        </SecondaryButton>
        <button type="button" class="text-xs text-gray-400 hover:text-gray-600 focus:outline-hidden" @click="cancel">
          ✕
        </button>
      </div>
    </div>

    <p v-if="submitted" class="mt-2 text-xs text-green-600">
      {{ t("success_message") }}
    </p>
  </div>
</template>

<script>
import { useI18n } from "vue-i18n";
import { mapActions } from "vuex";
import { SecondaryButton } from "@estaly/ui";

export default {
  name: "AiAnalysisFeedbackForm",

  components: { SecondaryButton },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: {
    analysableType: {
      type: String,
      required: true,
    },
    analysableId: {
      type: Number,
      required: true,
    },
    analysisType: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      formVisible: false,
      comment: "",
      loading: false,
      submitted: false,
    };
  },

  methods: {
    ...mapActions("aiAnalysisFeedbacks", ["submitFeedback"]),

    cancel() {
      this.formVisible = false;
      this.comment = "";
    },

    async submit() {
      if (!this.comment.trim()) return;

      this.loading = true;
      const response = await this.submitFeedback({
        analysableType: this.analysableType,
        analysableId: this.analysableId,
        analysisType: this.analysisType,
        comment: this.comment.trim(),
      });
      this.loading = false;

      if (response.success) {
        this.submitted = true;
        this.formVisible = false;
      }
    },
  },
};
</script>

<i18n src="./AiAnalysisFeedbackForm.i18n.json"></i18n>
